module.exports = __webpack_public_path__ + "static/img/maintenance-inactive.30d4455.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/icon/report/maintenance-inactive.svg
// module id = Fnjh
// module chunks = 215